module.exports = __webpack_public_path__ + "static/media/dco-poster.f0e58242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/dco-poster.jpg
// module id = 418
// module chunks = 0